module.exports = __webpack_public_path__ + "img/full-10.f3ee88ca.png";